import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { ChartDefinition } from 'src/shared/models/chart-definintions.model';
import { Chart } from 'angular-highcharts';
import { ReportService } from 'src/shared/services/report.service';
import { ReportData } from 'src/shared/models/report-data.model';
import { Observable, from, Subscription } from 'rxjs';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
  selector: 'smt-performancereport',
  templateUrl: './performance-report.component.html',
  styleUrls: ['./performance-report.component.scss']
})
export class PerformanceReportComponent implements OnInit {

  performanceChart : Chart;
  performanceData: ReportData;
  chartDefinition: ChartDefinition = new ChartDefinition();
  loading:boolean;
  reportSubscription : Subscription;
  
  private expandEventsSubscription: any;
  private filterEventSubscription: any;

  @Input() filtersUpdated: Observable<void>;
  @Input() reportFilters:ReportFilters;

  @Output() performanceDataUpdated = new EventEmitter();
  constructor(private _reportService:ReportService) { }

  ngOnInit() {
    this.drawEmpty();
    this.loading = true;
    if (this.filtersUpdated)
      this.filterEventSubscription = this.filtersUpdated.subscribe(() => this.getData());
  }

  drawEmpty()
  {

    this.performanceChart = this.chartDefinition.getPercentageTemplate
      (
        'Target Hours Vs. Worked Hours',
        'Pay Period Ending',
        'Variance',
        [],
        true
      );
  }

  drawGrid()
  {
    this.loading = false;

    if(!this.performanceData || this.performanceData.dataSets.length == 0)
      return;

    const minRows:number = 5;

    let chartData = MiscUtil.getDataFilteredByDataSetName(this.performanceData);

    this.performanceChart = this.chartDefinition.getColumnTemplate
      (
        'Target Hours Vs. Worked Hours',
        this.reportFilters.ReportView,
        'Variance',
        this.performanceData.xAxis
      );

    let chartSizeMinusOne = chartData.length - 1;

    // Add all but the last entry with the re-draw flag set to false this speeds up chart drawing
    chartData.slice(0,chartSizeMinusOne).forEach(dataSet =>
      {
        this.performanceChart.addSeries({type: 'column', name: dataSet.name, 	data:  dataSet.data},false,true);
      });

    this.performanceChart.addSeries({type: 'column', name: chartData[chartSizeMinusOne].name, 	data:  chartData[chartSizeMinusOne].data},true,true);

  }

  async getData()
  {

    this.loading = true;

    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();

    this.reportSubscription = from(this._reportService.GetPerformanceReport(this.reportFilters))
                 .subscribe(x => {
                    this.performanceData = x;
                    this.performanceDataUpdated.emit(this.performanceData);
                    this.drawGrid();
                 })
  }

  ngOnDestroy() {
    if(this.filtersUpdated)
      this.filterEventSubscription.unsubscribe();
    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();
  }


}
